module.exports = __webpack_public_path__ + "static/media/l10.32534e56.jpg";